module.exports = __webpack_public_path__ + "static/media/general-de-seguros-minus.f3a801ab.svg";